import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import AppContent from './AppContent';

// Simple wrapper page shown after returning from Stripe Checkout success URL.
// For now we just show a confirmation message and a button to go back
// into the main app (Profile → Subscription tab can be reached from there).
const SubscriptionSuccessPage: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  // session_id is available if we ever want to verify it with the backend.
  const sessionId = searchParams.get('session_id');

  useEffect(() => {
    // In the future we could call a backend endpoint to validate sessionId
    // or refresh subscription data explicitly. For now, the normal app
    // flow will fetch subscription info when the user navigates to Profile.
  }, [sessionId]);

  return (
    <div className="modal-overlay" onClick={() => {
      localStorage.setItem('app-activeTab', 'profile');
      localStorage.setItem('profile-activeTab', 'subscription');
      navigate('/');
    }}>
      <div
        className="upgrade-prompt-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <h2>Subscription Updated</h2>
        <p className="upgrade-description">
          Your subscription is now active. You can manage it from your profile&apos;s Subscription tab.
        </p>

        <div className="modal-actions">
          <button
            className="upgrade-btn"
            onClick={() => {
              localStorage.setItem('app-activeTab', 'profile');
              localStorage.setItem('profile-activeTab', 'subscription');
              navigate('/');
            }}
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionSuccessPage;
